<template>
  <div class="modal-mask">
    <section class="modal reduced">
      <!-- HEAD USER DETAILS -->
      <div class="content">
        <h1> {{$t('users.userDetailsTitle')}} {{user['first-name']}} {{user['name']}}</h1>
      </div>
      <hr>
      <div class="content">
        <div class="column">
          <p class="accentuate">{{$t('addUser.email')}}</p>
          {{user.email}}<br><br>
          <label>{{$t('addUser.phoneNumber')}}</label>
          {{user['phone-number']}}<br><br>
          <label>{{$t('addUser.enterprise')}}</label>
          {{user.company}}<br><br>
          <label>{{$t('addUser.permissions')}}</label>
          {{user['user-profile-name']}}<br><br>
        </div>
      </div>
      <hr>
      <div class="content">
        <div class="row">
          <a @click="$emit('close')">{{$t('users.closeDetails')}}</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Users from "@/services/Users";
import getProfiles from "@/mixins/getProfiles";

export default {
  props: ["parUserId"],
  mixins: [getProfiles],
  data() {
    return {
      user: []
    };
  },

  mounted() {
    this.getUser(this.parUserId);
  },
  methods: {
    getUser(id) {
      Users.getUserById(id)
        .then(res => {
          this.user = res.data;
          this.profile = res.data["user-profile-id"];
          this.getProfiles();
        })
        .catch(err => console.log(err));
    }
  }
};
</script>